import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import React, { useCallback, useEffect } from 'react';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './CancelAutorenewErrorModal.css';

const name = 'cancel-autorenew-error';
const modalName = `${name}-modal`;

interface Props {
    onClose?: () => void;
}

const messages = {
    title: 'Не удалось отключить автоплатёж',
    description: 'Оплата подписки Mail Space ещё в обработке. Отключите автоплатёж позже, тогда следующий уже не спишется',
    button: 'Понятно',
};

const sendRadar = (action: 'show' | 'click') =>
    sendDwh({
        label: action,
        eventCategory: 'modal',
        p: 'cloud-web-analytics',
        dwh_enabled: true,
        dwhData: { name },
    });

export const CancelAutoRenewErrorModal = ({ onClose }: Props) => {
    useEffect(() => sendRadar('show'), []);

    const onClick = useCallback(() => {
        onClose?.();
        sendRadar('click');
    }, [onClose]);

    return (
        <Dialog
            id={modalName}
            className={styles.card}
            onCancel={onClose}
            open
            closable
            closeOnEscape={true}
            closeOnDimmerClick={true}
            size={'tiny'}
            dimmer={false}
        >
            <Title data-test-id={`${modalName}-title`}>{messages.title}</Title>
            <Spacing size={12} />
            <Text className={styles.text} data-test-id={`${modalName}-description`}>
                {messages.description}
            </Text>
            <Spacing size={24} />
            <Button onClick={onClick} appearance={'neutral'} size={'l'} data-test-id={`${modalName}-button`}>
                {messages.button}
            </Button>
        </Dialog>
    );
};
